import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { upsertBankGuarantee } from "../thunks/upsertBankGuarantees";
import { setFetchState } from "../bankguaranteesDataSlice";
import { BankGuaranteeData } from "../types";

export const useBankGuaranteeUpsert = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (store) => store.data.clearing.bankguarantees.fetchState
  );

  const dispatch = useDispatch();
  const dispatchUpsertGuarantee = React.useCallback(
    (bankguarantee: BankGuaranteeData) => dispatch(upsertBankGuarantee(bankguarantee)),
    [dispatch]
  );

  React.useEffect(() => {
    dispatch(setFetchState({ type: "not-started" }));
  }, [dispatch]);

  return [fetchState, dispatchUpsertGuarantee] as [
    typeof fetchState,
    typeof dispatchUpsertGuarantee
  ];
};
